module.exports = __webpack_public_path__ + "cultura_modelo_mytho_.png?1c8bfabd7da7868cc6006f066a966da8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultura_modelo_mytho_.png
// module id = 1931
// module chunks = 2